














































































import { ref, createComponent, Ref, onMounted, onUnmounted } from '@vue/composition-api'
import { handlePagination } from '@/service/transferList'
import { DOWNLOAD_STATUS } from '@/constant'
import { getFileIcon,removeUserToken } from '@/helpers/common'
export default createComponent({
    setup(props, setupContext) {
        const downloadList = ref<any[]>([])
        let timer: any=null
        const { currentList, handleCurrentChange, pageSize, currentPageNum, updateCurrentList } = handlePagination(
            downloadList
        )
        const getInProgressList=async()=>{
            const res=await (window as any).Ait.fileSystem.refreshUploadList()
            let list: any[]=[],inProgressList: any[] = []
            if(res&&res.data){
                list=res.data.uploadList||[]
                if(list.length){
                    inProgressList=list.filter(item=>item.status==="uploading")
                }
            }
            if(!res||!list.length||!inProgressList.length){
                removeUserToken()
            }
        }
        const loadData = async () => {
            const res = await (window as any).Ait.fileSystem.getDownloadList()
            let downloadingList=[]
            if(res&&res.code&&res.code===2){
                clearInterval(timer)
            }else if(res&&res.length){
                downloadList.value = res
                updateCurrentList()
                downloadingList=res.filter(item=>item.status==="downloading")
            }
            if(!downloadingList.length){
                getInProgressList()
            }
        }
        const startAll = async () => {
            //console.log("startAll");
            const res = await (window as any).Ait.fileSystem.downloadResumeAll()
            //console.log(res);
            loadData()
        }
        const pauseAll = async () => {
            //console.log("pauseAll");
            const res = await (window as any).Ait.fileSystem.downloadPauseAll()
            //console.log(res);
            loadData()
        }
        const cancelAll = async () => {
            //console.log("cancelAll");
            const res = await (window as any).Ait.fileSystem.downloadRemoveAll()
            //console.log(res);
            loadData()
        }
        const pause = async row => {
            //console.log("pause", row);
            // row.status = 'pause'
            const res = await (window as any).Ait.fileSystem.downloadPause(row.id)
            //console.log(res);
            loadData()
        }
        const start = async row => {
            //console.log("start", row);
            // row.status = 'uploading'
            const res = await (window as any).Ait.fileSystem.downloadResume(row.id)
            //console.log(res);
            loadData()
        }
        const cancel = async row => {
            //console.log("cancel", row);
            const res = await (window as any).Ait.fileSystem.downloadRemove(row.id)
            //console.log(res);
            loadData()
        }

        onMounted(async () => {
            currentPageNum.value = 1
            loadData()
            timer = setInterval(async () => {
                loadData()
            }, 1000)
        })
        onUnmounted(() => {
            clearInterval(timer)
        })

        return {
            getFileIcon,
            DOWNLOAD_STATUS,
            downloadList,
            startAll,
            pauseAll,
            cancelAll,
            pause,
            start,
            cancel,
            currentList,
            handleCurrentChange,
            pageSize,
        }
    },
})
